import React from 'react';
import classNames from 'classnames';

// import withQueryParams from 'HOC/withQueryParams';
import { pushQueryParams } from 'services/history';
import Icon, { ICON_NAMES } from 'components/Icon';

const Category = props => {
  const { category, currentCategory, onChange } = props;

  return (
    <li className="left-menu__item">
      <button
        type="button"
        className={classNames('left-menu__link', {
          'left-menu__link--active':
            (!currentCategory && category.id === 'all') ||
            parseInt(currentCategory) === category.id ||
            currentCategory === category.id
        })}
        onClick={() => {
          pushQueryParams({ category: category.id });
          pushQueryParams({ page: 1 });
          onChange(category.id);
        }}
      >
        <span className="left-menu__text">{category.name}</span>
        <Icon name={ICON_NAMES.play} className="left-menu__icon" />
      </button>
    </li>
  );
};

export default Category;
